<template lang="pug">
.simulation
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('ActionTemplate.templateSimulation') }}
      v-spacer
      v-col(cols="auto")
        g-btn(
          color="primary",
          :disabled="disabledSimulation",
          @click="simulate",
        ) {{ $t('ActionTemplate.simulate') }}
    v-row
      v-col
        v-select(
          :label="$t('ActionTemplate.entity')",
          v-model="entity",
          :items="schema",
          item-text="name",
          return-object,
        )
      v-col
        app-simple-entity-search(v-if="entity", @input="setInstance", :entity="entity")
    v-row(v-if="isZplFile")
      v-col
        h3.primary--text {{ $t('ActionTemplate.labelDimensionsInches') }}
      v-spacer
      v-col
        v-text-field(
          :label="$t('ActionTemplate.LabelWidth')",
          v-model="width",
          type="number"
        )
      v-col
        v-text-field(
          :label="$t('ActionTemplate.LabelHeight')",
          v-model="height",
          type="number"
        )
    template(v-if="loading")
      v-skeleton-loader(
        class="mx-auto my-3"
        type="article"
      )
    template(v-if="result")
      v-row(v-if="isZplFile" style="place-content: center;")
        img(
          :src="labelImageSrc"
          style="max-width:300px;border: 2px solid black;"
        )
      v-row(v-if="isPDF" style="place-content: center;")
        object(
          v-if="!isResultError(result)",
          type="application/pdf",
          :data="dataPdf",
          width="1050",
          height="600",
        )
      v-row(v-else-if="isCsvFile")
        v-col(cols="12")
        h2.primary--text.overflow {{ $t('ActionTemplate.csvTablePreview') }}
        v-col(cols="12")
          div(v-html="csvContent")
      v-row(v-else-if="isTextFile")
        v-col(cols="12")
          h2.primary--text {{ $t('ActionTemplate.TextPreview') }}
        v-col(cols="12")
          div.overflow(v-html="textContent")
      v-row(v-else-if="isScripting")
        v-col(cols="12")
          h2(:class="getErrorColorClass(result)") {{ $t('ActionTemplate.consoleOutput') }}
        v-col(cols="12")
          pre {{ getConsoleOutput(result) }}
      v-row(v-else)
        v-col.d-flex.align-center
          h2.primary--text {{ $t('ActionTemplate.result') }}
        v-col(cols="12")
          div(v-html="result.body")
      v-row
        v-col.d-flex.align-center
          h2(:class="getErrorColorClass(result)") {{ $t('ActionTemplate.raw') }}
        v-col(cols="12")
          pre.overflow {{ result }}
</template>
<style>
.overflow {
  overflow: auto;
}

.csv-table {
  border: solid 1px #a1a1a1;
  border-collapse: collapse;
  border-spacing: 0;
  font: normal 13px Arial, sans-serif;
}

.csv-table tbody th {
  background-color: #5a5a5a;
  border: solid 1px #a1a1a1;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}

.csv-table tbody td {
  border: solid 1px #a1a1a1;
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
}
</style>
<script>
import EntityMixin from '@/mixins';
import axios from 'axios';
import { CREATE_PDF, CREATE_TEXT_FILE, CSV, ZPL, ZPL2, EXECUTE_SCRIPT } from '@/components/ActionTemplate/constants.js';


export default {
  mixins: [EntityMixin],
  data: () => ({
    entity: null,
    errors: {},
    result: null,
    entityInstance: null,
    loading: false,
    width: 4,
    height: 6,
    labelImageSrc: "",
  }),
  methods: {
    getErrorColorClass(result) {
      if(this.isResultError()) {
        return 'red--text';
      } else {
        return 'green--text';
      }
    },
    isResultError(){
      return this.errors != null && this.errors.length > 0;
    },
    getConsoleOutput(result) {
      if(this.isResultError(result)) {
        return result.ConsoleOutput;
      }
      
      return result.body;
    },
    async simulate() {
      try {
        this.loading = true;
        let endpoint = null;
        if (this.isPDF)
          endpoint = `/simulations/actionTemplate/${this.uid}/simulationPDF/${this.entity.name}/${this.entityInstance}`;
        else if (this.isTextFile)
          endpoint = `/simulations/actionTemplate/${this.uid}/simulationTextFile/${this.entity.name}/${this.entityInstance}`;
        else
          endpoint = `/simulations/actionTemplate/${this.uid}/simulation/${this.entity.name}/${this.entityInstance}`;
        let simulationPromise = axios.post(endpoint, {
          actionTemplate: this.instance,
        }, { params: { isSimulation: true } });
        simulationPromise.then(this.postSimulation);
        this.result = (await simulationPromise).data;
      } catch (error) {
        console.log(`[ERROR SIMULATING]`, error);
        this.errors = error.response.data.errors
      }
      finally {
        this.loading = false;
      }
    },
    setInstance(val) {
      this.entityInstance = val.id;
    },
    async postSimulation(response) {
      if (this.isZplFile)
        await this.getLabelImage(response.data.body)
      else if(this.isPDF || this.isCsvFile || this.isTextFile)
      {
        try{
          const data = JSON.parse(response.data); // if this passes there are errors in response
          this.errors = data.Errors;
          return data;
        } catch(e) { return response; } // means no error (all string no a json object)
      } else {
        this.errors = response.data.Errors;
      }
    },
    async getLabelImage(zpl) {
      var imageResponse = (await axios.post(
        `misc/ZplLabel/${this.width}/${this.height}`,
        JSON.stringify({ zpl }),
        {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'blob',
          transformRequest: (d) => d,
        })).data;
      this.labelImageSrc = await this.blobToBase64(imageResponse);
    },
    blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }
  },
  computed: {
    disabledSimulation() {
      return ((!this.entity && !this.entityInstance)
        || this.loading
        || !this.hasSelectedEntity)
        || (this.isZplFile && (!this.width || !this.height))
    },
    schema() {
      return this.$store.state.schema.all;
    },
    dataPdf() {
      return 'data:application/pdf;base64,' + this.result;
    },
    csvContent() {
      return this.$csvToHtmlTable(this.result.body, this.result.delimiter);
    },
    textContent() {
      let element = window.document.createElement("pre");
      element.textContent = this.result.body;
      return element.outerHTML;
    },
    uid() {
      return this.$route.params.item;
    },
    hasSelectedEntity() {
      return this.entityInstance;
    },
    isPDF() {
      return _.get(this.instance, 'action.name') === CREATE_PDF;
    },
    isTextFile() {
      return _.get(this.instance, 'action.name') === CREATE_TEXT_FILE;
    },
    isCsvFile() {
      return this.isTextFile && _.get(this.instance, 'content.fileExtension', "").toLowerCase() === CSV.toLowerCase();
    },
    isZplFile() {
      return this.isTextFile && (
        _.get(this.instance, 'content.fileExtension', "").toLowerCase() === ZPL.toLowerCase()
        || _.get(this.instance, 'content.fileExtension', "").toLowerCase() === ZPL2.toLowerCase()
      );
    },
    isScripting() {
      return _.get(this.instance, 'action.name') === EXECUTE_SCRIPT;
    }
  },
}
</script>
